import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import './index.css';

import { FormattedMessage } from 'react-intl';
export default function TopSearch({ searchArg, assignSearchArg, assignFlag }) {
  const { value } = searchArg;
  async function handleSearch() {
    if (value.trim()) {
      assignFlag(true);
      assignSearchArg({
        ...searchArg,
        identify: !searchArg.identify,
      });
    }
  }
  return (
    <header className='website-header'>
      <div className='words'>
        <div className='title'>
          <FormattedMessage id='ziyuan' />
        </div>
        <div className='introduction'>
          <FormattedMessage id='more' />
        </div>
      </div>
      <Input
        value={value}
        size='large'
        defaultValue={value}
        placeholder={'Search...'}
        onChange={e => {
          assignSearchArg({ ...searchArg, value: e.target.value.trim() });
          if (!e.target.value.trim()) {
            assignFlag(false);
          }
        }}
        onPressEnter={handleSearch}
        allowClear
        suffix={
          <span
            className='searchInputContainer'
            onClick={handleSearch}
          >
            <SearchOutlined
              key='Icon'
              style={{
                fontSize: '3.077vw',
                cursor: 'pointer',
                color: '#b5b5b5',
                margin: 'auto',
              }}
            />
          </span>
        }
      />
    </header>
  );
}
